<template>
  <el-cascader
    style="width: 100%"
    v-model="value2"
    :options="options"
    @change="handleChange"
    @active-item-change="handleItemChange"
    ref="cascader"></el-cascader>
</template>

<script>
  import data from './districts';
  import {getAreaByCityId, getProvCityList} from "@/services/area";

  export default {
    data() {
      return {
        value2: [],
        options: []
      };
    },
      props:["value"],
    async mounted() {
       await this.loadData();
       if(Array.isArray(this.value)){
           this.setAddress(this.value)
       }

      // this.$emit("init")
    },

    methods: {

      async setAddress(list){
        if (list ) {
          let find1, find2, find3;
          find1 = this.options.find((item2) => item2.label == list[0]);
          if (list.length >= 2) {
            find2 = find1.children.find((item2) => item2.label == list[1]);
          }
          if (list.length >= 3) {
            if (find2.children) {
              if (find2.children.length == 0) {
                const res = await this.loadArea(find2.value);
                if (res) {
                  find2.children = res;
                } else {
                  delete find2.children;
                }
              }
              if(find2.children){
                find3 = find2.children.find((item2) => item2.label == list[2]);
              }
            }
          }
          let item=[];
          if(find1){
            item.push(find1.value)
          }
          if(find2){
            item.push(find2.value)
          }
          if(find3){
            item.push(find3.value)
          }
          this.value2=item;
        }
      },

       handleChange(item) {
        this.value2 = item;
        let find1, find2, find3;
        find1 = this.options.find((item2) => item2.value == item[0]);
        if (item.length >= 2) {
          find2 = find1.children.find((item2) => item2.value == item[1]);
        }
        if (item.length >= 3) {
          find3 = find2.children.find((item2) => item2.value == item[2]);
        }
        let selectAddress = [];
        if (find1) {
          selectAddress.push(find1.label);
        }
        if (find2) {
          selectAddress.push(find2.label);
        }
        if (find3) {
          selectAddress.push(find3.label);
        }
        this.$emit("input", selectAddress)
      },

      async loadArea(cityId) {
        const res = await getAreaByCityId(cityId);
        if (res && res.data.length != 0) {
          return res.data.map(item2 => {
            return {label: item2.name, value: item2.id}
          });
        } else {
          return;
        }
      },

      async handleItemChange(item) {
        // console.log(this.$refs.cascader)
        let find1, find2;
        find1 = this.options.find((item2) => item2.value == item[0]);
        if (item.length >= 2) {
          find2 = find1.children.find((item2) => item2.value == item[1]);
        }

        if (item.length == 2) {
          const res = await this.loadArea(item[1]);
          if (res) {
            find2.children = res;
          } else {
            delete find2.children;
            this.$refs.cascader.handlePick();
            this.handleChange(item)
          }
        }

        // if (item.length == 1) {
        //   find1.children = this.getDistricts(item[0],1);
        // } else if (item.length == 2) {
        //   find2.children=this.getDistricts(item[1],2);
        //   if( find2.children.length==0){
        //     this.value=item;
        //     this.$refs.cascader.hideMenu();
        //   }
        // }else if (item.length == 3) {
        //   find3.children=this.getDistricts(item[2],3);
        //   if( find3.children.length==0){
        //     this.value=item;
        //     this.$refs.cascader.hideMenu();
        //   }
        // }
        // console.log( this.$refs.cascader)
        // console.log(this.value)
      },
      getDistricts(id, level) {
        let list = data[id];
        if (!list) {
          return [];
        }
        return Object.keys(list).map(item => {
          return {label: list[item], value: item, ...(level != 2 ? {children: []} : {})}
        })
      },
      async loadData() {
        const res = await getProvCityList();
        if (res) {
          this.options = res.data.children.map(item1 => {
            let children = item1.children.map(item2 => {
              return {label: item2.label, value: item2.id, children: []}
            })
            return {children, label: item1.label, value: item1.id}
          });
          // console.log(this.options)
        }
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/AddressPicked/index.vue